import moment from "moment"
import {CarouselItemProps} from "../components/molecules/CarouselItem/types"
import {ExpertModel} from "../types/ExpertModel"
import {ThoughtPiecesModel} from "../types/ThoughtPiecesModel"
// import {formatDateFromIsoStringToAbbreviatedDate} from "./formatDates"

export const convertThoughtPiecesToCarouselItemList = (
  thoughtPieceList: ThoughtPiecesModel[],
  cmsImageUrl: string,
  language: string,
): CarouselItemProps[] => {
  moment.locale(language)
  let carouselItemList: CarouselItemProps[] = []
  if (thoughtPieceList && thoughtPieceList.length > 0) {
    thoughtPieceList.map((item, index) => {
      carouselItemList.push({
        articleId: item.group,
        index: index,
        title: item.title,
        imageLargePath: item.imageLarge ? cmsImageUrl + item.imageLarge : "",
        imageMediumPath: item.imageMedium ? cmsImageUrl + item.imageMedium : "",
        imageSmallPath: item.imageSmall ? cmsImageUrl + item.imageSmall : "",
        author: item.authors && item.authors[0] ? item.authors[0].name : "",
        // date: formatDateFromIsoStringToAbbreviatedDate(item.date),
        date: moment(item.date).format("D MMM, YYYY").replace(".", ""),
        itemUrl: item.itemUrl,
      } as CarouselItemProps)
    })
  }
  return carouselItemList
}

export const parseResponseToExpertModel = (
  data: any,
  cmsImageUrl: string,
): ExpertModel => {
  return {
    fullPath: data?.fullPath || "",
    id: data?.group || "",
    imageLarge: data?.imageLarge ? cmsImageUrl + data?.imageLarge : "",
    imageMedium: data?.imageMedium ? cmsImageUrl + data?.imageMedium : "",
    imageSmall: data?.imageSmall ? cmsImageUrl + data?.imageSmall : "",
    itemUrl: data?.itemUrl || "",
    location: data?.locationHierarchy[0] || "",
    title: data?.title || "",
    name: data?.name || "",
    email: data?.email || "",
    textBlockValues: data?.textBlockValues || [],
    servicesDisplayTags: data?.tagTitles || [],
  } as ExpertModel
}
